<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol
                    ><h1 class="page__title">{{ $t(titlePage) }}</h1></CCol
                >
                <CCol>
                    <ButtonCreate
                        :title="$t('Add connection')"
                        @click="
                            $router.push({
                                name: 'add_provider_integration',
                            })
                        "
                    >
                        {{ $t("Add connection") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.integrations.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CCardHeader>
                    <div class="d-flex">
                        <TableSettings
                            :allFields="tables.integrations.allFields"
                            :activeFields.sync="tables.integrations.fields"
                        />
                    </div>
                </CCardHeader>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.integrations.items"
                                    :fields="tables.integrations.fields"
                                    :itemsPerPageSelect="{
                                        values: [5, 10, 20],
                                    }"
                                    :columnFilterValue.sync="
                                        tables.integrations.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.integrations.rows"
                                    v-bind="tables.integrations"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('Actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables.integrations
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'edit_provider_integration',
                                                                params: {
                                                                    uuid: tables
                                                                        .integrations
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("Edit")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            clone(
                                                                tables
                                                                    .integrations
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("Clone")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            archive(
                                                                tables
                                                                    .integrations
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("Archive")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: '3th_party_connections_logs',
                                                                params: {
                                                                    uuid: tables
                                                                        .integrations
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("Logs")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #_selected="{ item }">
                                        <td class="py-2">
                                            <CInputRadio
                                                name="_selected"
                                                :checked="
                                                    item ===
                                                    tables.integrations
                                                        .itemSelected
                                                "
                                                @update:checked="
                                                    selectItemTable(
                                                        'integrations',
                                                        item
                                                    )
                                                "
                                            />
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="'/provider-integrations'"
                                                :table="tables.integrations"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.integrations.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.integrations.page"
                                        :pages="tables.integrations.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.integrations.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import ButtonCreate from "~/components/ButtonCreate";
import ButtonExport from "~/components/ButtonExport";
import FilterDate from "~/components/FilterDate";
import FilterFields from "~/components/FilterFields";
/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/** Others */
import { cilPlus, cilSettings, cilBullhorn } from "@coreui/icons";
import TableSettings from "£lement/TableSettings";
import IntegrationsTable from "./config/tables/integrations";
import Swal from "sweetalert2";
export default {
    name: "InputsIntegrationsMainPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        ButtonCreate,
        ButtonExport,
        FilterDate,
        FilterFields,
        TableSettings,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilBullhorn,
    },
    data() {
        return {
            tables: {
                integrations: IntegrationsTable,
            },
        };
    },
    computed: {},
    methods: {
        itemPerPage(newValue) {
            this.tables.integrations.rows = newValue;
            this.updatePagination(this.tables.integrations.page);
        },
        updatePagination(newValue) {
            this.tables.integrations.page = newValue;
            this.updateData();
        },
        async updateData() {
            await this.updateTable({
                tableName: "integrations",
                url: "/provider-integrations",
                adapterFilters: (filters) => {
                    delete filters.where.created_at;
                    return filters;
                },
            });
            this.tables.integrations.itemSelected = null;
            this.tables.integrations.loading = false;
            this.updatePageLoading(false);
        },

        async clone(item) {

            const result = await Swal.fire({
                title: this.$t("Are you sure?"),
                text: this.$t("You are sure to clone this integration?"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.$t("Yes, clone it!"),
            });
            if (result.isConfirmed) {
                try {
                    this.updatePageLoading(true);
                    let response = await this.fetcher({
                        url: "/provider-integrations/" + item.uuid,
                        method: "GET",
                    });

                    let itemToClone = response._items;

                    response = await this.fetcher({
                        url: "/provider-integrations",
                        method: "POST",
                        data: {
                            name: itemToClone.name + " COPY",
                            plugin_marketing_credentials_uuid:
                                itemToClone.plugin_marketing_credentials_uuid,
                            action_uuid: itemToClone.action_uuid,
                            settings: JSON.parse(itemToClone.settings),
                        },
                    });
                    this.showMessageByMethod("POST");
                    this.updateData();
                } catch (error) {
                    this.showMessageError(error);
                } finally {
                    this.updatePageLoading(false);
                }
            }
        },

        async archive(item) {
            const result = await Swal.fire({
                title: this.$t("Are you sure?"),
                text: this.$t("You are sure to archive this integration?"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.$t("Yes, archive it!"),
            });
            if (result.isConfirmed) {
                try {
                    this.updatePageLoading(true);
                    await this.fetcher({
                        url: `/provider-integrations/${item.uuid}/archive`,
                        method: "PUT",
                    });
                    this.showMessageByMethod("PUT");
                    this.updateData();
                } catch (error) {
                    this.showMessageError(error);
                } finally {
                    this.updatePageLoading(false);
                }
            }
            
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style scoped lang="scss"></style>
